import React, { FC } from 'react'
import { useSelector } from 'react-redux'
import { State } from 'index'
import { Layout } from 'components/Layout'
import { BrandEditTemplate } from 'components/Templates'

const BrandEdit: FC = () => {
  const pathname = useSelector((state: State) => state.router.location.pathname)
  // /admin/brand/:brandId にマッチするパターン
  const isEdit = /^\/admin\/brand\/(?!create$)[^/]+$/.test(pathname)
  const brandId = isEdit ? pathname.split('/admin/brand/')[1] : undefined

  return (
    <Layout iconPath={'/icon/white/home.svg'} headline={'ブランド管理'} title={'ブランド管理'}>
      <BrandEditTemplate isEdit={isEdit} brandId={brandId} />
    </Layout>
  )
}

export default BrandEdit
